import {IFetchOddsComparisonTableOddsResp} from '../utils/event-odds-comparison-helpers';
import request from '../utils/request';
import {IMatchScheduleTableEvent} from "../components/OddsComparisonTable";
import {
  IClientChannelData,
  IDeal,
  IMarket,
  IMarketCompetitor,
  ITournament,
  IFeaturedEvent,
  IProviderCompetition,
} from '../utils/types';

export interface IMatchScheduleResponse {
  id: number,
  sportId: number,
  regionId: number,
  parentId: number,
  name: string,
  headerProviders: [],
  additionalName: string,
  events: IMatchScheduleTableEvent[],
}

export interface IFeaturedEventsResponse {
  tournament: ITournament;
  featuredEvents: IFeaturedEvent[];
}

export interface ITrackClickResponse {
  success: boolean,
}

export function fetchOddsComparisonTableMarketCompetitors(query: Object) {
  return request(`/api/market-competitors`, query) as unknown as Promise<IMarketCompetitor[]>;
}

export function fetchOddsComparisonTableMarkets(query: Object) {
  return request(`/api/markets`, query) as unknown as Promise<IMarket[]>;
}

export function fetchOddsComparisonTableOdds(query: Object) {
  return request(`/api/odds`, query) as unknown as Promise<IFetchOddsComparisonTableOddsResp>;
}

export function fetchClientChannelData(widgetId: number, channelId: number) {
  return request(`/api/client-channel-data/${widgetId}/${channelId}`) as unknown as Promise<IClientChannelData>;
}

export function fetchProviderDeals(query: Object) {
  return request(`/api/providers/deals`, query) as unknown as Promise<IDeal[]>;
}

export async function fetchLeagueScheduleData(query: Object) {
  return request(`/api/league-schedule/table-data`, query) as unknown as Promise<IMatchScheduleResponse>;
}

export function fetchFeaturedEventsData(query: Object) {
  return request(`/api/featured-events`, query) as unknown as Promise<IFeaturedEventsResponse>;
}

export function fetchPromotedProvider(query: Object) {
  return request('/api/providers/promoted-provider', query) as unknown as Promise<IProviderCompetition>;
}

export function fetchTrackOddsClick(query: Object) {
  return request(`/api/track/odds-click`, query) as unknown as Promise<IFeaturedEventsResponse>;
}

export function fetchTrackChannelClick(query: Object) {
  return request(`/api/track/channel-click`, query) as unknown as Promise<IFeaturedEventsResponse>;
}
